@for (scheme of schemas; track $index + scheme.scheme) {
	@if (scheme.display !== 'no') {
		<div
			class="product-recommendations"
			[ngClass]="{
				'hmf-mb-xxs hmf-mb-md-l': schemas?.length > 0 && !isCartOOSRecs && !isTabbedCarouselRecs && !isOOSSimilarProducts && !isVerticalGrid,
				'product-recommendation-card-carousel': homefieldCarouselEnabled
			}"
			[id]="sponsored ? 'sponsored-product' : ''"
		>
			<!-- Recommendation Heading -->
			<ng-container *ngIf="!homefieldCarouselEnabled && !isVerticalGrid && !isSidePanelRecsRedesign">
				<div
					class="header3 product-recommendations-header"
					[ngClass]="{'alternative-instock-header': isAlternativeInStock || isOOSRecommendations && !showViewMoreLink}"
					[ngStyle]="{'width': isPLPRecs ? '100%' : '97%'}"
				>
			<span
				*ngIf="scheme?.certonaDisplayText"
				[ngClass]="{'alternative-instock-text': isAlternativeInStock && !showViewMoreLink}"
				class="hmf-pl-s hmf-pl-m-0 certona-title-text"
			>
				{{ scheme?.certonaDisplayText }}
			</span>
					<hr
						*ngIf="scheme?.certonaDisplayText"
						class="header-hr"
						[ngClass]="sponsored ? 'sponsored-header-hr-override': ''"
					/>
					<a
						*ngIf="showViewMoreLink"
						href="/s/recommended-for-you"
						class="viewall"
						[attr.data-em]="'PDP_CertonaViewAll' + filterBy"
					>
						View All
					</a>
				</div>
			</ng-container>

			<!-- Standard Recommendations -->
			<div
				*ngIf="!isSidePanelRecs"
				class="product-recommendation-container"
				[ngClass]="{
					'alternative-instock-container': isAlternativeInStock || isOOSRecommendations,
					'center-content': isPLPRecs,
					'product-recommendation-container--vertical-grid': isVerticalGrid,
				}"
			>
				<div class="product-recommendation-card-container"
					[ngClass]="{
						'pla-product-recommendation-card-container': isPlaRecommendations,
						'hmf-p-0': homefieldCarouselEnabled,
						'hmf-display-flex hmf-flex-row': !isVerticalGrid,
						'product-recommendation-card-container--vertical-grid': isVerticalGrid,
					}">
					<ng-container *ngIf="homefieldCarouselEnabled && !showVertical;">
						<div class="hmf-w-100 hmf-mb-xxs">
							<hmf-carousel
								[title]="scheme?.certonaDisplayText"
								[showHeader]="showHeader"
								[subtitle]="sponsored ? 'Sponsored': ''"
								[showActionButton]="showViewMoreLink"
								actionButtonTitle="View All"
								(actionButtonClicked)="goToRecommendedForYou()">
								@for (
									item of scheme?.items;
									let index = $index;
									track trackByCertona($index, item);
								) {
									@if(index < productDisplayLimit) {
										<div class="product-recommendation-cards"
											[ngClass]="{
												'quickview': certonaQuickviewEnabled && showQVButtons || isCartOOSRecs,
												'oos-similar-products-recommendation': isOOSSimilarProducts
											}">
											<hmf-product-card
												[id]="sponsored && item?.ID ? 'piq-' + item.ID : ''"
												class="cursor-pointer"
												[productData]="recommendationDataService.mapSchemaItemToProductCardData(item)"
												[showATC]="showQVButtons || isCartOOSRecs"
												[buttonStyle]="isCartOOSRecs ||  isTabbedCarouselRecs ? 'secondary' : 'tertiary'"
												[buttonText]="isCartOOSRecs ? 'Replace' : atcCardText"
												[showReviewsStars]="false"
												[size]="cardSize ? cardSize : scheme?.cardSize"
												variant="recommendation"
												(cardClicked)="handleProductCardClicked(item)"
												(addToCartClicked)="handleATCBtnClick(item)"></hmf-product-card>
										</div>
									}
								}
							</hmf-carousel>
						</div>
					</ng-container>
					<ng-container *ngIf="showVertical && !homefieldCarouselEnabled">
						@for (
							item of scheme?.items;
							let index = $index;
							track trackByCertona($index, item);
						) {
							@if(index < productDisplayLimit) {
								<div class="product-recommendation-cards"
									[ngClass]="{
										'quickview': certonaQuickviewEnabled && showQVButtons || isCartOOSRecs,
										'oos-similar-products-recommendation': isOOSSimilarProducts
									}"
								>
									<hmf-product-card
										[id]="sponsored && item?.ID ? 'piq-' + item.ID : ''"
										class="cursor-pointer"
										[productData]="recommendationDataService.mapSchemaItemToProductCardData(item)"
										[showATC]="showQVButtons || isCartOOSRecs"
										[buttonStyle]="isCartOOSRecs ||  isTabbedCarouselRecs ? 'secondary' : 'tertiary'"
										[buttonText]="isCartOOSRecs ? 'Replace' : atcCardText"
										[showReviewsStars]="false"
										[size]="cardSize ? cardSize : scheme?.cardSize"
										variant="recommendation"
										(cardClicked)="handleProductCardClicked(item)"
										(addToCartClicked)="openQuickviewPanel(item?.ID, item?.URL)"
									/>
								</div>
							}
						}
					</ng-container>
					<ng-container *ngIf="!showVertical && !homefieldCarouselEnabled">
						<div
							*ngFor="let item of scheme?.items; let index = index; trackBy: trackByCertona;"
							class="product-recommendation-cards"
							[ngClass]="certonaQuickviewEnabled && showQVButtons || isCartOOSRecs ? 'quickview' : ''">
							<hmf-skeleton height="260px" width="200px" [loading]="!item" [inline]="true" />
							<div *ngIf="item && index < productDisplayLimit"
								class="dcsg-card hmf-h-100"
								[ngClass]="{
									'oos-product-recommendation': isOOSRecommendations,
									'product-recommendation': !isOOSRecommendations,
									'product-recommendation--vertical-grid': isVerticalGrid
								}"
							>
								<a class="hmf-display-flex hmf-flex-column hmf-align-items-stretch url"
								   [attr.data-em]="sponsored ? 'pdp_sponsored_dsgproductpage_' + index : ''"
								   [id]="sponsored && item.ID ? 'piq-' + item.ID : ''"
								   href="javascript:void(0)"
								   (click)="handleProductCardClicked(item)">
									<img class="hmf-align-self-center cross-sell-img product-image"
										 alt="a product"
										 [src]="item.ImageURL"
										 [ngClass]="imageSize"
										 [loading]="isCartOOSRecs ? '' : 'lazy'" />

									<div class="hmf-align-self-start cross-sell-desc product-name line-clamp">
										{{ item.Name | itemName }}
									</div>

									<div class="list-view-item-price hmf-align-self-start">
									<span *ngIf="item.minofferprice < item.maxmapprice || item.mapPriceIndicator === 1">
										{{ filterBy === 'cartempty_rr' || filterBy ==='cart2_rr' ? 'Add To Cart To See Price': 'See Price In Cart'}}
									</span>
										<ng-container *ngIf="
														item.minofferprice >= item.maxmapprice &&
														!item.isSkuRecommendation &&
														item.mapPriceIndicator === 0">
										<span [ngClass]="{
											'product-discount' : productHasDiscount(item)
										}">{{ item.minofferprice | currency }}</span>
											<span *ngIf="item.minofferprice !== item.maxofferprice" [ngClass]="{
											'product-discount' : productHasDiscount(item)
										}">
											{{isVerticalGrid ? ' - ':'&nbsp;to&nbsp;' }}{{ item.maxofferprice | currency }}
										</span>
										</ng-container>
										<ng-container *ngIf="
														item.minofferprice >= item.maxmapprice &&
														item.isSkuRecommendation &&
														item.mapPriceIndicator === 0">
											<span>{{ item.offerprice | currency }}</span>
										</ng-container>

										<ng-container *ngIf="productHasDiscount(item) && item.minofferprice >= item.maxmapprice &&
										!item.isSkuRecommendation &&
										item.mapPriceIndicator === 0">
											<span class="hmf-text-decoration-linethrough product-original-price">{{ item.minlistprice | currency }}</span>
											<span *ngIf="item.minlistprice !== item.maxlistprice" class="hmf-text-decoration-linethrough product-original-price">
											- {{ item.maxlistprice | currency }}
										</span>
										</ng-container>
									</div>

								</a>
								<button hmf-button
										*ngIf="certonaQuickviewEnabled && showQVButtons || isCartOOSRecs"
										id="certona-add-to-cart-{{ index }}"
										[height]="'small'"
										[variant]="'secondary'"
										[text]="isCartOOSRecs ? 'Replace' : atcCardText"
										[size]="'medium'"
										[loading]="false"
										[disabled]="false"
										[label]="isCartOOSRecs ? 'Replace' : atcCardText"
										class="hmf-mx-0 hmf-px-xs"
										(click)="openQuickviewPanel(item.ID, item.URL)"></button>
							</div>
						</div>
					</ng-container>
				</div>
			</div>

			@if (isSidePanelRecs) {
				@if (isSidePanelRecsRedesign) {
					<div class="hmf-display-flex hmf-flex-wrap hmf-justify-content-center product-recs-grid-container">
						<h3 class="hmf-header-bold-m hmf-mb-0 hmf-w-100">{{scheme?.certonaDisplayText}}</h3>
						@for (item of scheme?.items; track trackBySchema($index, item)) {
							<div>
								<hmf-product-card
									class="cursor-pointer"
									[productData]="recommendationDataService.mapSchemaItemToProductCardData(item)"
									[showReviewsStars]="false"
									[showATC]="false"
									[size]="isMobile ? 'small' : 'medium'"
									variant="recommendation"
									(cardClicked)="handleProductCardClicked(item)">
								</hmf-product-card>
							</div>
						}
					</div>
				} @else {
					<div class="hmf-display-flex hmf-mx-0 hmf-justify-content-center cart-product-recommendation-card-container">
						<div class="col-5half cart-product-recommendations dcsg-card" *ngFor="let item of scheme?.items; trackBy: trackBySchema;">
							<a class="hmf-display-flex hmf-flex-column hmf-align-items-stretch hmf-h-100 url" [href]="item?.URL">
								<source type="image/webp" [srcset]="item?.ImageURL"/>
								<img
									class="hmf-align-self-center cross-sell-img product-image"
									alt="a product"
									[src]="item?.ImageURL"
									[ngClass]="imageSize"
									loading="lazy"
								/>
								<div class="hmf-align-self-start cross-sell-desc product-name line-clamp">
									<span [innerHTML]="item?.Name"></span>
								</div>
								<div class=" list-view-item-price hmf-align-self-start">
									<span *ngIf="item?.minofferprice < item?.maxmapprice">See Price In Cart</span>
									<ng-container *ngIf="item?.minofferprice >= item?.maxmapprice">
										<span>{{ item?.minofferprice | currency }}</span><span *ngIf="item?.minofferprice !== item?.maxofferprice">&nbsp;to&nbsp;{{ item?.maxofferprice | currency }}</span>
									</ng-container>
								</div>
							</a>
						</div>
					</div>
				}
			}
		</div>
	}
}
